<template>
  <a-layout class="wrap">
    <a-layout-header class="header">
      <div class="leftInfo">
        <div class="real">
         <span class="realTime">{{hms}}</span>
         <span class="realData">{{newTime + ' ' + week}}</span>
        </div>
        <div class="userInfo">
          <a-dropdown :trigger="['click']">
            <div style="display:flex;align-items:center;">
              <img src="./../style/img/user.png" />
              <span>{{userName}}</span>
              <caret-down-outlined/>
            </div>
            <template #overlay>
              <a-menu>
                <!-- <a-menu-item key="0">
                  <div @click="editPassword">修改密码</div>
                </a-menu-item> -->
                <a-menu-item key="1">
                  <div @click="leave">退出登录</div>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
       </div>
       <div class="menuInfo">
        <a-select
          v-model:value="chooseMenu"
          :options="menus"
          style="width: 100px"
          :field-names="{ label: 'name', value: 'id'}"
          @change="changeMenu"
        ></a-select>
       </div>
      </div>
      <img src="/upload/dmsm/软件标题.png" class="index_text"/>
      <div class="site">
        <!-- <router-link :to="{path : '/preview.html',query:{filename:'dmsm/软件使用说明书.docx'}}"  target="_blank" >
         <img src="@/style/img/file.png" alt="" title="软件使用说明书" style="margin-right:10px; cursor: pointer;" >
        </router-link> -->
         <img src="@/style/img/退出-2.png" alt="" @click="leave" style="cursor: pointer;" >
      </div> 
    </a-layout-header>
    <a-layout
      :style="{
          display: 'flex',
          justifyContent :'space-between',
          overflow: 'hidden',
          padding: '10px 0px 10px 0px',
          margin:'0 0 0px 0',
          width: '100%',
        }"
    >
      <router-view ref="childMain" class="main_wrap" />
    </a-layout>
      <div v-if="isLeave">
        <div class="leaveBox">
          <div class="leaveInfo">
            <span class="leave_title">确定退出当前登录？</span>
            <div>
              <a-button class="btn_quxiao" @click="closeBox">取消</a-button>
              <a-button class="btn_ok btn" @click="leaveSystem">确定</a-button>
            </div>
          </div>
          <img src="@/style/img/关闭.png" class="close" @click="closeBox">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div>
        </div>
        <div class="chart_bg" @click="closeBox"></div>
      </div>
      <div v-if="isEdit">
        <div class="editBox">
          <div class="leaveInfo">
            <span class="edit_title">修改密码</span>
            <div style="width:80%;display: flex;justify-content: center;">
              <a-form
              :model="editInfo"
              :label-col="{ span: 9 }"
              :rules="rules"
              @finishFailed="changeError"
              @finish="changePassword"
              class="formStyle"
            >
            <a-row>
              <a-col :span="20">
                <a-form-item
                label="旧密码:"
                name="old"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <a-input-password v-model:value="editInfo.old" />
              </a-form-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="20">
                <a-form-item
                label="新密码:"
                name="new"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <a-input-password v-model:value="editInfo.new" />
              </a-form-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="20">
                <a-form-item
                label="确认密码:"
                name="sure"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <a-input-password v-model:value="editInfo.sure" />
              </a-form-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="24" style="display: flex;justify-content: center;">
                  <a-button class="btn_quxiao" @click="closeEditBox">取消</a-button>
                  <a-button class="btn_ok btn" html-type="submit">确定</a-button>
              </a-col>
            </a-row> 
            </a-form>
            </div>
          </div>
          <img src="@/style/img/关闭.png" class="close" @click="closeEditBox">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div>
        </div>
        <div class="chart_bg" @click="closeBox"></div>
      </div>
      <!-- <div v-if="showLayoutPicture">
        <div class="showPicture">
           <div class="layout_main">
            <div class="layout_head">终端安装布置图</div>
            <div class="layout_picture">
            <router-link :to="{path:'/photoPreview.html',query:{imgURL:`${imgURL}`}}" target="_blank"> 
              <img :src="imgURL" class="pictureStyle"/>
            </router-link>
              
            </div>
           </div>
          <img src="@/style/img/关闭.png" class="close" @click="closeLayoutPicture">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div class="chart_bg" @click="closeLayoutPicture"></div>
      </div> -->
    </a-layout>
  </template>
  <script>
  import moment from "moment";
  import dayjs from 'dayjs'
  import config from '@/utils/config'
  import { uuid } from "vue-uuid";//让文件名唯一
  import {getReport,updataSiteInfo,findReport,getDictDataByDictType} from '../api/index'
  import { CaretDownOutlined} from '@ant-design/icons-vue'
  const menuList = [
    {
        id:'/map',
        name:'地图页'
      },{
        id:'/index.html',
        name:'云端首页'
      },
      {
        id:'/dataStat',
        name:'数据统计'
      },
      {
        id:'/algorithmMaintain',
        name:'算法维护'
      },
      {
        id:'/accountManagement',
        name:'账号管理'
      },
  ]
  export default {
        created() {
          
        },
         mounted() {
          this.getUserType()
          this.getTime()
          this.userName = JSON.parse(localStorage.getItem("loginInfo")) ? JSON.parse(localStorage.getItem("loginInfo")).userName : ''
          this.chooseMenu = window.location.pathname
          // 设置定时器
           this.timer = setInterval(() => {
           setTimeout(() => {
            this.hms = moment().format("HH:mm:ss");
          }, 0);
        }, 1000);
        },
        beforeUnmount() {
          clearInterval(this.timer)
        },
        components: {
          CaretDownOutlined
          // HomeOutlined
        },
        data() {
            return {
              site:{ //站点信息
                name:'',
                substation:'',//站点id
              },
              userName : '',
              showLayoutPicture:false,
              isShowPhoto : false,//是否显示曲线（弹出框）
              isLeave:false,//显示是否离开
              hms : moment().format("HH:mm:ss"),
              newTime:'',
              week : '',
              timer : null,
              heightWidth:100,
              searchText:'',
              menus:[],
            isEdit:false,
            editInfo:{
                old:'',
                new:'',
                sure:''
            },
              rules:[{
                
                new:{ required: true, message: '请输入新密码' },
                sure:{ required: true, message: '请输入' }
              }],
              userType:{}
            }
            
          },
        methods : {
          //获取用户类型
          getUserType() {
            let query = JSON.parse(localStorage.getItem("loginInfo")) ? JSON.parse(localStorage.getItem("loginInfo")).userType : ''
            getDictDataByDictType().then(res => {
              if(res.data && res.data.length > 0) {
                let obj = {}
                res.data.forEach(element => {
                  if(element.dictLabel) {
                    obj[element.dictLabel] = element.dictValue
                  }
                });
                this.userType = obj
                if(this.userType[query] == '变电站用户' || query === "") {
                  this.menus = menuList.filter(item => item.name == "云端首页")
                }
                else {
                  this.menus = menuList
                }
              }
              
            })
          },
          updataSite() {
            updataSiteInfo({
              id : this.site.substation,
              name : this.site.name
            }).then(res => {
              if(res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
                localStorage.clear();
                this.$router.push({
                  path: config.loginURL
                  })
                }
              if(res.success && res) {
                this.getTree()
              }
            }).catch((err) => {
              this.$message.info(err);
            })
          },
          // //获取站点信息
          //  getSiteInfo() {
          //     siteInfo(this.site.substation).then(res => {
          //       if(res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          //         localStorage.clear();
          //         this.$router.push({
          //             path: config.loginURL
          //           })
          //        }
          //       this.site.name = res.data.name;
          //     }).catch(() => {
          //       this.$message.info("获取站点信息失败");
          //     });
          // },
          //获取装置图
          // showLayOut() {
          //     getLayOut().then(res => {
          //       if(res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          //         localStorage.clear();
          //         this.$router.push({
          //             path: config.loginURL
          //           })
          //        }
          //         let photo = new Blob([res],{type:'image/jpeg'});
          //         this.imgURL = URL.createObjectURL(photo);
          //         this.showLayoutPicture = true;
  
          //     }).catch(() => {
          //       // console.log(err);
          //       this.$message.info("获取装置图失败");
          //     });
          // },
          //关闭弹出来的图片
          // closeLayoutPicture() {
          //     this.showLayoutPicture = false;
          // },
          //退出界面
          leaveSystem() {
              localStorage.clear();
              this.$router.push({
                      path: config.loginURL
                    })
          },
          //显示退出界面的窗口
          leave() {
              this.isLeave = true;
          },
          //修改密码
          editPassword() {
            this.isEdit = true
          },
          closeEditBox() {
            this.isEdit = false
          },
          changePassword(e) {
              this.isEdit = false
            // console.log(e)
          },
          changeError(e) {
            this.isEdit = true
          },
          // 获取当前的日期
          getTime() {
                let now = new Date();
                let a = new Array("日", "一", "二", "三", "四", "五", "六");
                let week = now.getDay();
                let str = "星期" + a[week];
                let year = now.getFullYear();
                let month = now.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                let days = now.getDate();
                days = days < 10 ? "0" + days : days;
                this.newTime = year + "-" + month + "-" + days;
                this.week = str;
                //初始时间
                
                let startTime = dayjs(`${year}-${month}-01 00:00:00`)
                let endTime = startTime.add(1,"M")
                this.activeTime = [startTime,endTime]
          },
          //不显示弹窗
          closeBox() {
              this.isLeave = false;
          },
          changeMenu(e) {
            this.$router.push(e)
          },
        }
      }
  </script>
  
  <style scoped> 
  .previewDocument {
    background-color: #000614;
  }
  
  .wrap {
    background-image: url("../style/img/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-bottom: 10px;
  }
  .header {
    background: url("../style/img/top.png") repeat;
    background-size: 100% 100%;
    background-position: center;
    height: 85px;
    width: 100%;
    display: flex;
    justify-content:space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .leftInfo {
    width: 30%;
    display: flex;
  }
  .real {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .realTime {
    font-size: 1vw;
    line-height: 1vw;
    font-family: DengXian, DengXian-Regular;
    font-weight: 400;
    text-align: left;
    color: #a1fdfe;
  }
  .realData {
     font-size: 0.8vw;
     line-height: 0.8vw;
     font-family: DengXian, DengXian-Regular;
     font-weight: 400;
     text-align: left;
     color: #7fe1e8;
  }
  .userInfo {
    margin-left: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .userInfo span {
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #c7c7c7;
    margin-left: 3px;
  }
  .menuInfo {
    margin-left: 10px;
  }
  .index_text {
     width: 30vw;
  }
  .site {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 30%;
    /* flex: 1; */
  
  }
  .site_info {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .site_input {
    margin-right: 40px;
    width: 45%;
  }
  .imgStyle {
    width: 0.9vw;
  }
  .site_text {
    color: #ffffff;
    font-size: 0.8vw;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    
  }
  .info {
      height: 80px;
      width: 100%;
      padding: 10px;
      box-sizing:border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      border: 1px solid #19889B;
      background-color: #000614;
      box-shadow : inset 0px 0px 25px 3px #0376ac;
      
  }
  .fenge {
    flex:1;
    /* width: 6%; */
    text-align: center;
  }
  .head_text {
  font-size: 1vw;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: left; 
  color: #ffffff;
  display: flex;
  align-items: center;
  }
  .btn {
  margin-right:10px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400; 
  line-height: 14px;
  background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
  border: 1px solid;
  border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
  .btn_quxiao {
  margin-right:24px;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400; 
  line-height: 14px;
  background: transparent;
  border: 1px solid;
  border-image: linear-gradient(0deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  padding : 4px 24px
  }
  .ant-btn.btn_quxiao> span {
    display: inline-block;
    background:linear-gradient(-41deg,#0eb4dd 0%, #01efbc 100%);
    background-clip: text;
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent
  
  }
  .btn_ok {
    padding : 4px 24px
  }
  .ant-table-striped :deep(.table-striped) td {
    background-color: #fafafa;
  }
  .reportPhoto {
    height:18px;
    cursor: pointer;
  }
  
  .reportPhoto:hover,
  .reportPhoto:active {
    cursor: pointer;
  }
  
  .btn2 {
     font-size: 14px;
     font-family: Microsoft YaHei, Microsoft YaHei-Regular;
     font-weight: 400; 
     line-height: 14px;
     background: linear-gradient(-45deg,#00a8fb 0%, #03bdfa 100%);
     border: 1px solid;
     border-image: linear-gradient(0deg, #39beff 0%, #1fffff 100%) 1 1;
  }
  
  .footer {
    height:64px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    background: url("../style/img/bottom.png") no-repeat;
    background-size: 100% 100%;
    font-size: 0.8vw;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
    margin: 0 10px 0 10px;
  }
  
  .chartPhoto {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width:900px;
    height:64%;
    background: linear-gradient(#15273f 0%, #1d3c52 100%);
    border: 1px solid #2b76a1;
    z-index: 100;
    display: flex;
    flex-direction: column;
  }
  .leaveBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width:30%;
    height:30%;
    background: linear-gradient(#15273f 0%, #1d3c52 100%);
    border: 1px solid #2b76a1;
    z-index: 100;
    display: flex;
    flex-direction: column;
  }
  .close {
    position: absolute;
    top: 0;
    right:0;
    transform :translate(50%,-50%);
    z-index: 200;
    width: 2.4vw;
  }
  .info_lt,.info_rb,.info_rt,.info_lb{
      position:absolute;
      z-index: 100;
  }
  .info_lt {
      top: 1px;
      left: 1px;
  }
  .info_rb {
      bottom: 1px;
      right: 1px;
  }
   .info_rt{
      top: 1px;
      right: 1px;
  }
  .info_lb {
      bottom: 1px;
      left: 1px;
  }
  .info_right {
      display: flex;
      /* width: 25%; */
      align-items: center;
      justify-content: space-between;
  }
  .chart_head {
    background: url('../style/img/弹窗头.png') no-repeat;
    background-position: center;
    height: 42px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    /* text-align: center; */
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .chartStyle {
    flex: 1;
  }
  .chart_bg {
    position: absolute;
    top:0;
    left: 0;
    width:100%;
    height:100%;
    background-color:#1f1f1f79;
    z-index:80;
  }
  
  .leaveInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    gap:30px
  }
  
  .leave_title {
  font-size: 18px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  }
  .formStyle {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .showPicture {
    position: absolute;
    top: 50%;
    left: 50%;
    width : 40%;
    transform: translate(-50%,-50%);
    z-index: 100;
    border:1px solid #2b76a1;
    background:linear-gradient(#15273f 0%, #1d3c52 100%);
  
  }
  .layout_main {
    display: flex;
    flex-direction:column;
    gap:10px
  }
  .layout_head {
    background: url('../style/img/弹窗头.png') no-repeat;
    background-position: center;
    height: 42px;
    font-size: 1vw;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .layout_picture {
    flex: 1;
    padding: 20px;
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .layout_picture a {
    display:flex;
    justify-content: center;
    align-content: center;
  }
  .pictureStyle {
      width:80%;
      background-color: #ffffff;
  }
  .editBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width:30%;
    height:50%;
    background: linear-gradient(#15273f 0%, #1d3c52 100%);
    border: 1px solid #2b76a1;
    z-index: 100;
    display: flex;
    flex-direction: column;
  }
  .edit_title {
    font-size: 18px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
  }
  /* ::v-deep .ant-select-single .ant-select-selector .ant-select-selection-item, 
  ::v-deep .ant-select-single .ant-select-selector .ant-select-selection-placeholder{
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #08f6ff !important;
  } */
  ::v-deep .ant-input-password-icon {
    color:#24B4BE;
  }
  ::v-deep .ant-dropdown-open .anticon  {
    transform: rotate(180deg);
  }
</style>
  
